import React__default, { forwardRef, useRef } from 'react';
import { AccordionItem, AccordionHeader, AccordionTrigger, AccordionContent, Accordion as Accordion$1 } from '@radix-ui/react-accordion';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const AccordionSingleElement = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(Accordion$1, _extends({
    ref: innerRef
  }, props), children);
});
AccordionSingleElement.displayName = 'AccordionSingleElement';
const AccordionMultipleElement = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(Accordion$1, _extends({
    ref: innerRef
  }, props), children);
});
AccordionMultipleElement.displayName = 'AccordionMultipleElement';
/**
 * Contains all the parts of an accordion.
 */
const Root = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const {
    type
  } = props;
  if (type === 'multiple') {
    return /*#__PURE__*/React__default.createElement(AccordionMultipleElement, _extends({
      ref: innerRef
    }, props));
  }
  return /*#__PURE__*/React__default.createElement(AccordionSingleElement, _extends({
    ref: innerRef
  }, props));
});

/**
 * Contains all the parts of a collapsible section.
 */
const Item = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(AccordionItem, _extends({
    ref: innerRef
  }, props), children);
});

/**
 * Wraps an `Accordion.Trigger`. Use the `asChild` prop to update it to the appropriate heading level for your page.
 */
const Header = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(AccordionHeader, _extends({
    ref: innerRef
  }, props), children);
});

/**
 * Toggles the collapsed state of its associated item. It should be nested inside of an `Accordion.Header`.
 */
const Trigger = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(AccordionTrigger, _extends({
    ref: innerRef
  }, props), children);
});

/**
 * Contains the collapsible content for an item.
 */
const Content = /*#__PURE__*/forwardRef(({
  children,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(AccordionContent, _extends({
    ref: innerRef
  }, props), children);
});

// exports
Root.displayName = 'Accordion';
Item.displayName = 'Item';
Header.displayName = 'Header';
Trigger.displayName = 'Trigger';
Content.displayName = 'Content';
var Accordion = Object.assign(Root, {
  Item,
  Header,
  Trigger,
  Content
});

export { Accordion as default };
